import React from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function PayAndShip() {
    return (
        <Container className="mb-5">
            <Row>
                <Col>
                    <h1 className="fs-4 fw-bold mb-4">Оплата и доставка</h1>
                    <h2 className="fs-5 fw-bold mb-2">Условия доставки</h2>
                    <p>Доставка осуществляется курьерской службой до двери или до пункта выдачи, а также самовывозом по адресам компании.</p>
                    <h2 className="fs-5 fw-bold mb-2">Условия оплаты</h2>
                    <p><strong>Наличный расчёт</strong><br/>
                        При самовывозе товара оплата может осуществляется наличным расчётом. При получении вам выдадут чек.</p>
                    <p><strong>Банковской картой</strong><br/>
                        Для выбора оплаты товара с помощью банковской карты на соответствующей странице необходимо нажать кнопку «Оплата банковской картой».
                        Возврат переведённых средств, производится на ваш банковский счёт в течение 5−30 рабочих дней (срок зависит от банка, который выдал вашу банковскую карту).
                        Оставляя свои персональные данные, Вы даете добровольное согласие на обработку своих персональных данных. Под персональными данными понимается любая информация, относящаяся к Вам, как субъекту персональных данных (ФИО, дата рождения, город проживания, адрес, контактный номер телефона, адрес электронной почты, род занятости и пр). Ваше согласие распространяется на осуществление любых действий в отношении ваших персональных данных, которые могут понадобиться для сбора, систематизации, хранения, уточнения (обновление, изменение), обработки (например, отправки писем или совершения звонков) и т. п. с учетом действующего законодательства.</p>

                    <p>ЮРИДИЧЕСКАЯ ИНОФРМАЦИЯ<br/>
                        Индивидуальный предприниматель<br/>
                        Галич Александр Сергеевич<br/>
                        Юридический адрес: 403010, Волгоградская обл., Городищенский район, рп. Ерзовка, ул. Солнечная, д.6<br/>
                        ИНН 344212182709<br/>
                        ОГРНИП 315344300014164<br/>
                        Расчетный счет 40802810909500022915<br/>
                        Банк: ООО "Банк Точка"<br/>
                        БИК 044525104<br/>
                        Кор./счет 30101810745374525104</p>
                </Col>
            </Row>
        </Container>
    );
}

export default PayAndShip;